// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"988d8383","55":"684da3cf","230":"684da3cf","405":"f7110ba0","578":"7419205b","629":"4db4193a"}[chunkId] + ".chunk.css";
};